export const SOLVE_V2_BASE_URL = 'dashboard-controls/solve/v2';
export const SOLVE_EMAIL_BASE_URL = 'solve/email';
export const SOLVE_AUTOPILOT_BASE_URL = 'solve/autopilot';
export const ORCHESTRATOR_AUTOFLOW_BASE_URL =
  '/dashboard-controls/orchestrator/autoflow';
export const SOLVE_INTENT_TESTS_BASE_URL = 'solve/intent-tests';
export const SSEL_BASE_URL = 'ssel';
export const SOLVE_AUTOFLOW_BASE_URL = '/dashboard-controls/solve/autoflow';
export const BROWSER_AGENT_CONFIG_URL =
  '/dashboard-controls/browser-agent-config';
